import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';

const ADMIN_ROLES = ['Admin', 'Manager'];
const CUSTOMER_ROLES = ['Customer'];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('@features/landing/landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@features/landing/landing-page/landing-page.component').then(m => m.LandingPageComponent)
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    data: { roles: ADMIN_ROLES },
    loadComponent: () =>
      import('@features/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
  },
  {
    path: 'admin/:tab',
    canActivate: [authGuard],
    data: { roles: ADMIN_ROLES },
    loadComponent: () =>
      import('@features/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent)
  },
  {
    path: 'customer',
    canActivate: [authGuard],
    data: { roles: CUSTOMER_ROLES },
    loadComponent: () =>
      import('@features/customer/customer-dashboard/customer-dashboard.component').then(m => m.CustomerDashboardComponent)
  },
  {
    path: 'customer/:tab',
    canActivate: [authGuard],
    data: { roles: CUSTOMER_ROLES },
    loadComponent: () =>
      import('@features/customer/customer-dashboard/customer-dashboard.component').then(m => m.CustomerDashboardComponent)
  },
  { path: '**', redirectTo: '' }
];
